<template>
    <div class='form auth-boxed bg-light'>
        <div class='form-container'>
            <div class='form-form'>
                <div class='form-form-wrap'>
                    <div class='form-container'>
                        <div class='form-content'>
                            <img src='@/assets/images/deppes/deppes-dark.png' class='mb-5' width='250' alt='Deppes'>
                            <h5 v-if='!has2Fa'>Autenticação</h5>
                            <div v-if='has2Fa'>
                                <h5 class='mb-2'>Concluir verificação em duas etapas</h5>
                                <p class='text-muted'>
                                    Um código de verificação de uso único foi enviado ao endereço de e-mail que você
                                    registrou.
                                </p>
                            </div>

                            <form v-if='has2Fa' @submit.prevent='onSubmitCode' class='text-start mt-5'>
                                <text-input
                                    type='number'
                                    label='Digite o código abaixo para prosseguir'
                                    v-model='code'
                                    :errors='toRaw(formErrors?.code)'
                                    placeholder='Digite aqui seu código'
                                    :required='true' />

                                <div class='mt-4 mb-3 text-center'>
                                    <p>Não recebeu um código?
                                        <a href='#' class='fw-bold text-primary' @click.prevent='resendCode'>Reenviar agora</a>
                                    </p>
                                </div>
                                
                                <div class='d-sm-flex justify-content-between mb-4'>
                                    <div class='field-wrapper'>
                                        <AppButton type='submit' text='Verificar e fazer login' :load='load'
                                                   :show-text-load='false' />
                                    </div>
                                </div>
                                
                            </form>

                            <form v-else class='text-start' @submit.prevent='onSubmit'>
                                <div class='form'>
                                    <div id='username-field' class='field-wrapper input'>
                                        <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24'
                                             viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2'
                                             stroke-linecap='round' stroke-linejoin='round'
                                             class='feather feather-mail'>
                                            <path
                                                d='M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z'></path>
                                            <polyline points='22,6 12,13 2,6'></polyline>
                                        </svg>

                                        <text-input
                                            label='EMAIL ou CPF'
                                            v-model='formData.login'
                                            :errors='toRaw(formErrors?.login)'
                                            placeholder='Digite seu email ou CPF' />
                                    </div>

                                    <div id='password-field' class='field-wrapper input mb-2'>
                                        <div class='d-flex justify-content-between'>
                                            <label for='password'>SENHA</label>
                                            <a href='javascript:void(0)' class='forgot-pass-link'
                                               @click='onModalRecovery'>
                                                Esqueceu a senha?
                                            </a>
                                        </div>
                                        <svg
                                            xmlns='http://www.w3.org/2000/svg'
                                            width='24'
                                            height='24'
                                            viewBox='0 0 24 24'
                                            fill='none'
                                            stroke='currentColor'
                                            stroke-width='2'
                                            stroke-linecap='round'
                                            stroke-linejoin='round'
                                            class='feather feather-lock'
                                        >
                                            <rect x='3' y='11' width='18' height='11' rx='2' ry='2'></rect>
                                            <path d='M7 11V7a5 5 0 0 1 10 0v4'></path>
                                        </svg>

                                        <text-input
                                            :type='pwd_type'
                                            v-model='formData.password'
                                            :errors='toRaw(formErrors?.password)'
                                            placeholder='Digite sua senha' />
                                        <svg
                                            @click='set_pwd_type'
                                            xmlns='http://www.w3.org/2000/svg'
                                            width='24'
                                            height='24'
                                            viewBox='0 0 24 24'
                                            fill='none'
                                            stroke='currentColor'
                                            stroke-width='2'
                                            stroke-linecap='round'
                                            stroke-linejoin='round'
                                            id='toggle-password'
                                            class='feather feather-eye'
                                        >
                                            <path d='M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z'></path>
                                            <circle cx='12' cy='12' r='3'></circle>
                                        </svg>
                                    </div>
                                    <div class='d-sm-flex justify-content-between mb-4'>
                                        <div class='field-wrapper'>
                                            <AppButton type='submit' text='Entrar' :load='load'
                                                       :show-text-load='false' />
                                        </div>
                                    </div>

                                    <!--                                    <p class='signup-link'>Não possui registro?-->
                                    <!--                                        <router-link to='/'>Criar Conta</router-link>-->
                                    <!--                                    </p>-->
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <app-modal :show='showModal' id='modal-recovery' size='xs' @onClose='showModal = false'>
            <template #title>Recuperação de Senha</template>
            <template #body>
                <form @submit.prevent='onSubmitRecovery'>
                    <div class='text-center mb-4'>
                        <h5>Informe seu E-mail ou CPF para iniciar o processo de recuperação de senha</h5>
                    </div>
                    
                    <text-input
                        label='Email ou CPF' 
                        placeholder='Digite seu E-mail ou CPF' 
                        v-model='mailRecovery'
                        required 
                        :errors="mailRecoveryErrors ? [mailRecoveryErrors] : null"
                    />

                    <hr class='border'>
                    <div class='d-flex justify-content-between mt-3'>
                        <app-button icon='fa-solid fa-xmark' class='me-4' text='Cancelar' variant='default'
                                    @click='showModal = false' />

                        <app-button type='submit' icon='fa-solid fa-envelope' text='Enviar'
                                    variant='success' :load='loadBtn' />
                    </div>
                </form>
            </template>

        </app-modal>
    </div>
    
    <HelperSupportAuth />
</template>

<script setup>
    import { onMounted, reactive, ref, toRaw } from 'vue';
    import '@/assets/sass/authentication/auth-boxed.scss';

    import { useMeta } from '@/composables/use-meta';
    import { useRouter } from 'vue-router';
    import AppButton from '@/components/AppButton.vue';
    import { useStore } from 'vuex';
    import { handleAxiosError, isCpf, isEmail, justNumbers, validateCpf } from '@/helpers';
    import TextInput from '@/components/TextInput.vue';
    import AppModal from '@/components/AppModal.vue';
    import { useToast } from 'vue-toastification';
    import HelperSupportAuth from '@/components/Typebot/HelperSupportAuth.vue';

    useMeta({ title: 'Autenticação' });
    const pwd_type = ref('password');
    const load = ref(false);
    const loadBtn = ref(false);
    const showModal = ref(false);
    const has2Fa = ref(false);
    const mailRecovery = ref(null);
    const mailRecoveryErrors = ref(null);
    const router = useRouter();
    const store = useStore();
    const toast = useToast();

    const formData = ref({
        login: '',
        password: ''
    });

    const code = ref(null);
    const user_id = ref(null);

    const formErrors = ref({});

    const onModalRecovery = () => {
        mailRecoveryErrors.value = null;
        mailRecovery.value = null;
        showModal.value = true;
    };

    const onSubmitRecovery = async () => {
        const login = mailRecovery.value;
        
        if(!isEmail(login) && !isCpf(login)) {
            mailRecoveryErrors.value = 'Informe um email ou cpf valido.';
            return;
        }else {
            mailRecoveryErrors.value = null;
        }
        
        try {
            loadBtn.value = true;
            const { data } = await axios.post(`recovery-password`, { login: login });
            showModal.value = false;
            Swal.fire('Recuperação de senha solicitada com sucesso.', data.message, 'success');
        } catch (e) {
            handleAxiosError(e);
        } finally {
            loadBtn.value = false;
        }
        
    };

    const resendCode = async () => {
        try {
            load.value = true;
            const { data } = await axios.get(`login/resend-code/${user_id.value}`);
            toast.success(data.message);

            load.value = false;
        } catch (e) {
            load.value = false;
            handleAxiosError(e);
        }
    };

    const handlerCommitData = (data) => {                    
        store.commit('user/setToken', data.token);
        store.commit('user/setUser', data.user);
        store.commit('user/setContractName', data.contract_name);
        store.commit('relationalNps/setContractDateStart', data.contract_date_start);
    }

    const onSubmitCode = async () => {
        try {
            load.value = true;
            const { data } = await axios.post('login/check-code-2fa', { code: code.value, user_id: user_id.value });

            if (data.user.update_password) {
                window.location.href = '/redefinir-senha/' + data.user.remember_token + '?login=' + formData.value.login + '&type=' + data.redirect;
            } else {
                handlerCommitData(data);

                if (data.redirect === 'admin') {
                    window.location.href = '/';
                } else {
                    window.location.href = '/portal';
                }
            }

            load.value = false;
        } catch (e) {
            load.value = false;
            if (e.response.status === 401) {
                formErrors.value.code = [e.response.data.message];
            } else if (e.response.status === 422) {
                formErrors.value = e.response.data.errors;
            } else {
                handleAxiosError(e);
            }
        }
    };

    const onSubmit = async () => {
        try {
            load.value = true;
            const { data } = await axios.post('login', formData.value);            

            if (data?.has2Fa) {
                has2Fa.value = true;
                user_id.value = data?.user_id;
            } else {
                if (data.user.update_password) {
                    window.location.href = '/redefinir-senha/' + data.user.remember_token + '?login=' + formData.value.login + '&type=' + data.redirect;
                } else {
                    handlerCommitData(data);                                        
                    if (data.redirect === 'admin') {
                        window.location.href = '/';
                    } else {
                        window.location.href = '/portal';
                    }
                }
            }

            load.value = false;
        } catch (e) {
            if (e.response.status === 401) {
                formErrors.value.login = [e.response.data.message];
            } else if (e.response.status === 422) {
                formErrors.value = e.response.data.errors;
            } else {
                handleAxiosError(e);
            }

            load.value = false;
        }
    };

    const set_pwd_type = () => {
        if (pwd_type.value === 'password') {
            pwd_type.value = 'text';
        } else {
            pwd_type.value = 'password';
        }
    };
    
    onMounted(() => {
        store.dispatch('relationalNps/clearRelationalNpsData');
        store.dispatch('transactionalNps/removeLastSearchPerformedDate');
    })
</script>
